import { searchChats, searchMessages } from "../api";
import { useSearchStore } from "./store";

export const loadMore = async () => {
  const {
    searchQuery,
    hasMoreChats,
    hasMoreMessages,
    pageChats,
    pageMessages,
    chats,
    messages,
    setChats,
    setMessages,
    setPageChats,
    setPageMessages,
    setHasMoreChats,
    setHasMoreMessages,
    setLoadingMore,
  } = useSearchStore.getState();

  if (!searchQuery) return;
  setLoadingMore(true);

  try {
    if (hasMoreChats) {
      const res = await searchChats({ query: searchQuery, page: pageChats });
      if (res.success) {
        const newChats = res.result ?? [];
        setChats([...chats, ...newChats]);
        setPageChats(pageChats + 1);
        setHasMoreChats(newChats.length >= 30);
      }
    } else if (hasMoreMessages) {
      // const res = await searchMessages({ query: searchQuery, page: pageMessages });
      // if (res.success) {
      //   const newMsgs = res.result ?? [];
      //   setMessages([...messages, ...newMsgs]);
      //   setPageMessages(pageMessages + 1);
      //   setHasMoreMessages(newMsgs.length >= 30);
      // }
    }
  } finally {
    setLoadingMore(false);
  }
};
